import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IFlowRunSpecOutputStepViewModel } from '../types/IFlowRunSpecOutputStepViewModel';

export interface RunFlowOnOutputStepsParams {
  readonly flowId: string;
  readonly flowOutputStepIds: string[];
  readonly flowRunSpecOutputStepParams: IFlowRunSpecOutputStepViewModel[];
}

export interface RunFlowOnOutputStepsResult extends IResult {
}

export class RunFlowOnOutputStepsRequest extends Request<RunFlowOnOutputStepsParams, RunFlowOnOutputStepsResult> {
  constructor(params: RunFlowOnOutputStepsParams) {
    super('runFlowOnOutputSteps', params);
  }
}


